export default function TwitterIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="white" fill-opacity="0.87" />
      <path
        d="M32.1876 12.4504C31.2911 12.8371 30.3155 13.1154 29.3107 13.2238C30.354 12.604 31.1352 11.6248 31.5079 10.4699C30.5289 11.0523 29.4564 11.4607 28.338 11.6769C27.8706 11.1772 27.3052 10.7791 26.6772 10.5074C26.0491 10.2357 25.3719 10.0963 24.6876 10.0978C21.9191 10.0978 19.6925 12.342 19.6925 15.0959C19.6925 15.4827 19.7394 15.8694 19.8156 16.2415C15.67 16.0247 11.9728 14.0442 9.51477 11.0119C9.0669 11.7769 8.83219 12.6479 8.83508 13.5344C8.83508 15.2688 9.71692 16.7981 11.0616 17.6975C10.2692 17.6663 9.49527 17.4485 8.80286 17.0618V17.1233C8.80286 19.5521 10.5197 21.5648 12.8077 22.0277C12.3781 22.1393 11.9362 22.1964 11.4923 22.1976C11.1671 22.1976 10.8595 22.1654 10.5489 22.1214C11.1818 24.1019 13.0245 25.5404 15.2189 25.5873C13.5021 26.9321 11.3517 27.7231 9.01672 27.7231C8.59778 27.7231 8.21106 27.7084 7.80969 27.6616C10.0245 29.0825 12.6525 29.9028 15.4825 29.9028C24.67 29.9028 29.6974 22.2914 29.6974 15.6848C29.6974 15.468 29.6974 15.2512 29.6827 15.0344C30.6554 14.3225 31.5079 13.4406 32.1876 12.4504Z"
        fill="#333333"
      />
    </svg>
  );
}
